// src/communaute/CommunautePage.jsx
//
// Page « Communauté » du dashboard créateur : Fil · Mes publications.
// Les deux onglets sont affichés dans TopBarEspace (fixe en haut, à la
// place du titre de page) — cette page se contente d'afficher le
// contenu correspondant à l'onglet, déterminé par la route :
//   /EspaceClient/communaute              → Fil communauté
//   /EspaceClient/communaute/publications → Mes publications
//
// La messagerie a sa propre page (MessageriePage.jsx) et les
// notifications restent gérées par la cloche déjà présente en haut
// du dashboard (TopBarEspace) — pas besoin de les dupliquer ici.

import { useLocation } from 'react-router-dom';
import { Newspaper } from 'lucide-react';

import { getToken } from './api';
import { FilCommunaute, MesPublications } from './Publications';
import { UiHost, Vide } from './ui';

export default function CommunautePage() {
    const location = useLocation();
    const onglet = location.pathname.endsWith('/publications') ? 'mes' : 'fil';

    if (!getToken()) {
        return (
            <div className="flex min-h-[60vh] items-center justify-center">
                <Vide icone={Newspaper} titre="Accès réservé aux membres" sous="Connectez-vous pour accéder à la communauté" />
            </div>
        );
    }

    return (
        <div className="text-gray-900">
            <div className="mx-auto max-w-6xl">
                {onglet === 'fil' ? <FilCommunaute /> : <MesPublications />}
            </div>

            <UiHost />
        </div>
    );
}